import useLocalStorageState from 'use-local-storage-state';

const printerSettingsKey = 'printerSettings';

export function usePrinterSettings() {
  return useLocalStorageState(printerSettingsKey, {
    defaultValue: {
      enableAutoPrinting: false,
      printer: ''
    }
  });
}
